import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
const links = [
  ["/", "Home"],
  ["/about", "About"],
  ["/skills", "Skills"],
  ["/resume", "Resume"],
  ["/portfolio", "Projects"],
  ["/contact", "Contact"],
];
export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <nav className="navigation" aria-label="Main navigation">
        <Link className="wordmark" to="/" onClick={() => setOpen(false)}>
          rahul<span>.</span>
        </Link>
        <button
          className="menu-toggle"
          aria-expanded={open}
          aria-controls="nav-links"
          onClick={() => setOpen(!open)}
        >
          {open ? "Close ✕" : "Menu ☰"}
        </button>
        <div id="nav-links" className={`nav-links ${open ? "is-open" : ""}`}>
          {links.map(([to, label]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              onClick={() => setOpen(false)}
            >
              {label}
            </NavLink>
          ))}
        </div>
        {/* <a className="nav-hello" href="mailto:rahul.pivs@gmail.com">Say hello ↗</a> */}
      </nav>
    </header>
  );
}
